<template>
    <div class="header-wrapper" ref="header">
        <div class="container-headder">
            <div style="display: flex;align-items: center;width: 100%;height: 100%">
                <div style="width: 50%;display:flex">
                    <div class="cotentBox-logo">
                        <img v-if="!isZhh" :src="require('@/assets/logo-global.png')" alt="" />
                        <img v-else :src="require('@/assets/logo-zzh.png')" alt="" />
                    </div>
                    <div class="search-input" v-if="language === 'zh'">
                        <el-select v-model="valuePavilion" :popper-append-to-body="false" :placeholder="$t('header.choose_role')"  @change="handleChoose()" class="select-style"
                        popper-class="select-popper" style="width: 90px">
                            <el-option
                            v-for="item in optionsChooseCn"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <input type="text" v-model="searchExhibitor" @keyup.enter="handleSearch" style="background: none;margin-right: 10px;color: #778DB3"  :placeholder="$t('header.choose_exhibition')" v-if="this.valuePavilion == '100'">
                        <input type="text" v-model="searchGoods" @keyup.enter="handleSearch" style="background: none;margin-right: 10px;color: #778DB3" :placeholder="$t('header.choose_goods')" v-else>
                        <img src="../../../assets/search-header.png" class="icon" style="margin-left:55px;margin-right:10px" alt=""  @click="handleSearch" />
                    </div>
                    <div class="search-input" v-else>
                        <el-select v-model="valuePavilion" :popper-append-to-body="false" :placeholder="$t('header.choose_role')"  @change="handleChoose()" class="select-style"
                        popper-class="select-popper"  style="width: 130px">
                            <el-option
                            v-for="item in optionsChooseEn"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <input type="text" v-model="searchExhibitor" @keyup.enter="handleSearch" style="background: none;margin-right: 10px;color: #778DB3"  :placeholder="$t('header.choose_exhibition')" v-if="this.valuePavilion == '100'">
                        <input type="text" v-model="searchGoods" @keyup.enter="handleSearch" style="background: none;margin-right: 10px;color: #778DB3" :placeholder="$t('header.choose_goods')" v-else>
                        <img src="../../../assets/search-header.png" style="margin-left:20px;margin-right:10px" class="icon" alt=""  @click="handleSearch" />
                    </div>
                </div>
                <div class="main" style="width: 50%">
                    <div class="cotentBox-home" @click="goPage('/exhibition')">
                        <span class="header-titile-name">{{$t("header").home}}</span>
                    </div>
                    <div class="cotentBox-pavilion" @click="goPage('/plateformInfo')" style="cursor: pointer;font-size: 18px;line-height: 25px;font-weight: 600;color: #49546B">
                        <span>{{$t("header").info}}</span>
                    </div>
                    <div class="cotentBox-pavilion">
                        <el-dropdown @command="handleCommandOptionsPavilion" placement="bottom-end">
                            <span class="el-dropdown-link header-titile-name">
                                {{$t("header").pavilion}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="(item, index) in optionsPavilion"
                                    :key="index"
                                    :label="language == 'zh' ? item.base_info.data.cn.name : item.base_info.data.en && item.base_info.data.en.name || ''"
                                    :value="item.id"
                                    :command="item.id"
                                    >{{language == 'zh' ? item.base_info.data.cn.name : item.base_info.data.en && item.base_info.data.en.name || ''}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="cotentBox-pavilion">
                        <el-dropdown @command="handleCommandOptionsExhibition">
                            <span class="el-dropdown-link header-titile-name">
                                {{$t("header").exhibition}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="item in optionsExhibition"
                                    :key="item.id"
                                    :label="language == 'zh' ? item.base_info.data.cn.name : item.base_info.data.en && item.base_info.data.en.name || ''"
                                    :value="item.id"
                                    :command="item.id"
                                    >{{language == 'zh' ? item.base_info.data.cn.name : item.base_info.data.en && item.base_info.data.en.name || ''}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="cotentBox-pavilion">
                        <el-dropdown @command="handleCommandOptionsExhibitionEnd">
                            <span class="el-dropdown-link header-titile-name">
                                {{$t("header").review}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="item in optionsExhibitionEnd"
                                    :key="item.id"
                                    :label="language == 'zh' ? item.base_info.data.cn.name : item.base_info.data.en && item.base_info.data.en.name || ''"
                                    :value="item.id"
                                    :command="item.id"
                                    >{{language == 'zh' ? item.base_info.data.cn.name : item.base_info.data.en && item.base_info.data.en.name || ''}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="cotentBox-pavilion" v-if="language == 'zh'" style="cursor: pointer;font-size: 18px;line-height: 25px;font-weight: 600;color: #49546B">
                        <!-- <span>便企服务</span> -->
                        <el-dropdown @command="handleCommandBianMing">
                            <span class="el-dropdown-link header-titile-name">
                                便企服务<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="item in optionsBianMing"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    :command="item.id"
                                    >{{item.name}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="cotentBox-language">
                        <img src="../../../assets/lang-change.png" alt="">
                        <el-select v-model="languageValue" placeholder="请选择" @change="toggleLanguage" style="width: 30px">
                            <el-option
                                v-for="item in optionsLanguage"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <!-- <div class="cotentBox-language">
                        <span @click="toggleLanguage('zh')" :class="[language === 'zh' && 'active']">CN</span>
                        <span class="line">/</span>
                        <span @click="toggleLanguage('en')" :class="[language === 'en' && 'active']">EN</span>
                    </div> -->
                    <div class="cotentBox-userInfo">
                        <LoginBtn :hideMenu="hideMenu" />
                    </div>      
                </div>
            </div>
        </div>
        <div>
            <!-- 展商搜索 -->
            <el-drawer
                :visible.sync="drawerExhibitor"
                :direction="directionExhibitor"
                :modal="false"
            >   
                <div class="exhibitorDrawer">
                    <div class="exhibitorDrawer-search-name">
                        <span>{{$t("header").search_exhibitor}}</span>
                        <span style="margin-left: 10px">{{searchExhibitor}}</span>
                    </div>
                    <div class="exhibitorDrawer-search-place">
                        <span class="pick-place">{{$t("header").area_selection}}：</span>
                        <div class="pick-button">
                            <el-cascader
                            size="large"
                            :options="options"
                            v-model="selectedOptions"
                            @change="handleChange"
                            style="width: 340px">
                            </el-cascader>
                            <img src="../../../assets/area/ss.png" style="width: 20px;height: 20px;cursor: pointer" alt=""  @click="handleSearchPlace" />
                        </div>
                    </div>
                    <ul class="el-row" v-if="hasData > 0">
                        <li class="el-col el-col-6 exhibitor-item-wrap" v-for="(item, index) in exhibitorData" :key="index">
                            <div class="exhibitor-item" @click="goExhibitorDetail(item.id, item.exhibition_id,item.vhall.id)">
                                <div class="exhibitor-img-content" >
                                    <!-- <div class="company-view-item"  @click.stop="handleExhibitorsStore(item)" >
                                        <p class="store-default store-active" :class="item.is_store == 1 ? 'active' : 'unactive'">
                                            <el-tooltip class="item" effect="dark" :content="handleLangExhibitorsStore(item)" placement="top" >
                                                <i  class="iconfont icon-shoucang- icon-store"></i>
                                            </el-tooltip>
                                        </p>
                                    </div> -->
                                    <img v-if="item.is_store == 0" @click.stop="collectExhibitors(item)" class="new-store" src="~statics/mobileShouye/newUnstore.png">
                                    <img v-if="item.is_store == 1" @click.stop="cancelCollectExhibitors(item)" class="new-store" src="~statics/mobileShouye/newStore.png">
                                    <img class="exhibitor-img" :src="item.company && item.company.logo_url || logo" />
                                </div>
                                <div class="exhibitor-content">
                                    <div class="exhibitor-content-name">
                                        <span>{{item.company.name}}</span>
                                    </div>
                                    <div class="exhibitor-content-place">
                                        <span>{{$t("header").place}}:</span>
                                        <span>{{ item.company.address}}</span>
                                    </div>
                                    <div class="exhibitor-content-exhname">
                                        <span>{{$t("header").exhibition}}:</span>
                                        <span>{{language == 'zh' ? item.exhibition_name.cn.name : item.exhibition_name.en.name}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="no_data">
                        <img src="../../../assets/empty.png" alt="">
                        <span style="font-size: 21px">抱歉，没有找到您想到要的结果，请试试别的关键词吧！</span>
                    </div>
                    <div style="margin-top:10px;text-align:center" v-if="totalPage > 1" class="page">
                        <Pagination :child-msg="pageparam" @callFather="callFather"></Pagination>
                    </div>
                </div>
            </el-drawer>
            <!-- 展品搜索 -->
            <el-drawer
                :visible.sync="drawerGoods"
                :direction="directionGoods"
                :modal="false"
            >      
                <div class="goodsDrawer">
                    <div class="goodsDrawer-search-name">
                        <span>{{$t("header").search_goods}}</span>
                        <span style="margin-left: 10px">{{searchGoods}}</span>
                    </div>
                    <ul class="el-row" v-if="hasData > 0">
                        <li class="el-col el-col-6 goods-item-wrap" v-for="(item, index) in goodsData" :key="index">
                            <div class="goods-item">
                                <div class="goods-img-content" >
                                    <img v-if="item.is_store == 0" @click.stop="collect(item)" class="new-store" src="~statics/mobileShouye/newUnstore.png">
                                    <img v-if="item.is_store == 1" @click.stop="cancelCollect(item)" class="new-store" src="~statics/mobileShouye/newStore.png">
                                    <!-- <div class="company-view-item"  @click.stop="handleExhibitsStore(item)">
                                        <p class="store-default store-active" :class="item.is_store == 1 ? 'active' : 'unactive'">
                                            <el-tooltip class="item" effect="dark" :content="handleLangExhibitsStore(item)" placement="top" >
                                                <i  class="iconfont icon-shoucang- icon-store"></i>
                                            </el-tooltip>
                                        </p>
                                    </div> -->
                                    <img class="goods-img" :src="language == 'zh' ? item.product.cn.main_image && item.product.cn.main_image[0].url || logo : item.product.en.main_image && item.product.en.main_image[0].url || logo" />
                                </div>
                                <div class="goods-content">
                                    <div class="goods-content-name">
                                        <span>{{language == 'zh' ? item.product.cn.name : item.product.en && item.product.en.name || ''}}</span>
                                    </div>
                                    <div class="goods-content-place">
                                        <span>{{$t("header").exhibitor}}:</span>
                                        <span>{{ item.company.name}}</span>
                                    </div>
                                    <div class="goods-content-exhname">
                                        <span>{{$t("header").exhibition}}:</span>
                                        <span>{{language == 'zh' ? item.exhibition.base_info.data.cn.name : item.exhibition.base_info.data.en && item.exhibition.base_info.data.en.name || ''}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="no_data">
                        <img src="../../../assets/empty.png" alt="">
                        <span style="font-size: 21px">抱歉，没有找到您想到要的结果，请试试别的关键词吧！</span>
                    </div>
                    <div style="margin-top:10px;text-align:center" v-if="totalPage > 1" class="page">
                        <Pagination :child-msg="pageparam" @callFather="callFather"></Pagination>
                    </div>
                </div>
            </el-drawer>
            <!-- 根据地点搜索展商 -->
            <el-drawer
                :visible.sync="drawerPlaceExhibitor"
                :direction="directionPlaceExhibitor"
                :modal="false"
            >   
                <div class="exhibitorDrawer">
                    <div class="exhibitorDrawer-search-name">
                        <span>{{$t("header").search_exhibitor}}</span>
                        <span style="margin-left: 10px">{{searchExhibitor}}</span>
                    </div>
                    <div class="exhibitorDrawer-search-place">
                        <span class="pick-place">{{$t("header").area_selection}}</span>
                        <div class="pick-button">
                            <el-cascader
                            size="large"
                            :options="options"
                            v-model="selectedOptions"
                            @change="handleChange"
                            style="width: 340px">
                            </el-cascader>
                            <img src="../../../assets/area/ss.png" style="width: 20px;height: 20px;cursor: pointer" alt=""  @click="handleSearchPlace" />
                        </div>
                    </div>
                    <ul class="el-row">
                        <li class="el-col el-col-6 exhibitor-item-wrap" v-for="(item, index) in exhibitorSearchPlaceData" :key="index">
                            <div class="exhibitor-item">
                                <div class="exhibitor-img-content" >
                                    <div class="company-view-item"  @click.stop="handleExhibitorsStore(item)" >
                                        <p class="store-default store-active" :class="item.is_store == 1 ? 'active' : 'unactive'">
                                            <el-tooltip class="item" effect="dark" :content="handleLangExhibitorsStore(item)" placement="top" >
                                                <i  class="iconfont icon-shoucang- icon-store"></i>
                                            </el-tooltip>
                                        </p>
                                    </div>
                                    <img class="exhibitor-img" :src="item.company && item.company.logo_url || logo" />
                                </div>
                                <div class="exhibitor-content">
                                    <div class="exhibitor-content-name">
                                        <span>{{item.company.name}}</span>
                                    </div>
                                    <div class="exhibitor-content-place">
                                        <span>{{$t("header").place}}:</span>
                                        <span>{{ item.company.address}}</span>
                                    </div>
                                    <div class="exhibitor-content-exhname">
                                        <span>{{$t("header").exhibition}}:</span>
                                        <span>{{language == 'zh' ? item.exhibition_name.cn.name : item.vhall.exhibition_name.en.name}}</span>
                                    </div>
                                </div>
                            </div>
                            
                        </li>
                    </ul>
                    <div style="margin-top:10px;text-align:center" v-if="totalPage > 1" class="page">
                        <Pagination :child-msg="pageparam" @callFather="callFather"></Pagination>
                    </div>
                    <!-- 分页 -->
                    <div v-show="isEmpty" style="text-align:center;color:#aaa;height:200px;position: absolute;top: 280px;right:0px;left:0px">
                        <i class="el-icon-tickets" style="font-size: 30px"></i>
                        <p style="margin-top:20px;font-size: 25px">{{ language === 'zh' ? '暂无相关数据' : 'No Data' }}</p>
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { changeLanuage } from "@/lang";
import LoginBtn from "@/components/LoginButton";
import { mapState } from "vuex";
import api from "@/api";
import { regionDataPlus } from 'element-china-area-data'
import Pagination from '../../../components/Pagination'
import { all_exhibition_id } from '../../../utils/exhibitId'

export default {
    props: {
        hideMenu: {
            type: Boolean,
            default: false
        },
        isZhh: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            logo: require("../../../../static/no-logo-new.png"),
            options: regionDataPlus,
            selectedOptions: [],
            searchExhibitor: '',
            searchGoods: '',
            // language:  '',
            input: '',
            optionsChooseCn: [{
            value: '100',
            label: '展商',
            }, {
            value: '101',
            label: '展品'
            }],
            optionsChooseEn: [{
            value: '100',
            label: 'Exhibitors',
            }, {
            value: '101',
            label: 'Exhibits'
            }],
            optionsPavilion: [
            ],
            optionsExhibition: [
            ],
            optionsBianMing:[{
                id: 1,
                name: '原产地证申请'
            }],
            optionsExhibitionEnd: [],
            valuePavilion: '100',
            drawerExhibitor: false,
            directionExhibitor: 'btt',
            drawerGoods: false,
            directionGoods: 'btt',
            drawerPlaceExhibitor: false,
            directionPlaceExhibitor: 'btt',
            exhibitorData: [
            ],
            exhibitorSearchPlaceData: [],
            goodsData: [
            ],
            totalPage: 0,
            pageparam: {
                totalNum: 0,
                currentPage: 1,
                size: 15
            },
            province : '',
            city : '',
            area : '',
            isEmpty: true,
            optionsPavilionStatus: '',
            optionsExhibitionStatus: '',
            optionsExhibitionEndStatus: '',
            newoption: [],
            newoptionEnd: [],
            hasData: '',
            optionsLanguage: [{
            value: 'zh',
            label: 'CN'
            }, {
            value: 'en',
            label: 'EN'
            },],
            languageValue: ''
        };
    },
    mounted() {
        // this.language = localStorage.getItem("language") || "zh";
        this.$store.dispatch("getUserInfo");
    },
    created(){
        this.getOptionsPavilion()
        this.getOptionsExhibition()
        this.getOptionsExhibitionEnd()
        this.languageValue = this.optionsLanguage[0].value;
    },
    components: {
        Pagination,
        LoginBtn
    },
    computed: {
        ...mapState(["userInfo","language"]),
    },
    watch: {
        '$route'() {
            this.drawerExhibitor = false;
        }
    },
    methods: {
        handleCommandBianMing(){
            var tempwindow=window.open('_blank')
            tempwindow.location = 'http://login.qiye.ccpiteco.net/'
        },
        goBianmin(){
            var tempwindow=window.open('_blank')
            tempwindow.location = 'http://login.qiye.ccpiteco.net/'
        },
        handleExhibitorsStore(_item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else {
                if(_item.is_store == '0') {
                    this.exhibitorsStore(_item);
                }else {
                    this.exhibitorsCancelStore(_item)
                }
            }
        },
        handleLangExhibitorsStore(_item) {
            if(_item.is_store) {
                if(this.language == 'zh') {
                    return '已收藏'
                }else {
                    return 'Stored'
                }
            }else {
                if(this.language == 'zh') {
                    return '收藏'
                }else {
                    return 'Store'
                }
            }
        },
         //展商收藏
        collectExhibitors(item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else{
                api.isCollectExhibitors({
                    exhibition_id: item.exhibition_id,
                    company_id:  item.company.id 
                }).then((res) => {
                    if (res.res == 1) {
                        item.is_store = 1;
                        this.$message({
                            type: 'success',
                            message: '收藏成功'
                        })
                        // this.$notify({ type: 'success', message: '收藏成功' });
                    }
                });
            }
        },
        cancelCollectExhibitors(item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else{
                api.noCollectExhibitors({
                    exhibition_id: item.exhibition_id,
                    company_id:  item.company.id
                }).then((res) => {
                    if (res.res == 1) {
                        item.is_store = 0;
                        this.$message({
                            type: 'success',
                            message: '取消收藏'
                        })
                        // this.$notify("取消收藏");
                    }
                });
            }
        },
        //展品收藏
        collect(item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else{
                api.isCollectProduct({
                    exhibition_product_id: item.id
                }).then((res) => {
                    if (res.res == 1) {
                        item.is_store = 1;
                         this.$message({
                            type: 'success',
                            message: '收藏成功'
                        })
                    }
                });
            }
            
        },
        cancelCollect(item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else{
                api.noCollectProduct({
                    exhibition_product_id: item.id
                }).then((res) => {
                    if (res.res == 1) {
                        item.is_store = 0;
                        this.$message({
                            type: 'success',
                            message: '取消收藏'
                        })
                    }
                });
            }
        },
        exhibitorsStore(_item) {
            api.isCollectExhibitors({
                exhibition_id: _item.exhibition_id,
                company_id: _item.company.id
            }).then((res) => {
                if (res.res == 1) {
                    this.$message.success("收藏成功");
                    _item.is_store = 1;
                }
            });
        },
        exhibitorsCancelStore(_item) {
            api.noCollectExhibitors({
                exhibition_id: _item.exhibition_id,
                company_id: _item.company.id
            }).then((res) => {
                if (res.res == 1) {
                    this.$message.success("取消收藏");
                    _item.is_store = 0;
                }
            });
        },
        handleExhibitsStore(_item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else {
                if(!_item.is_store) {
                    this.exhibitsStore(_item);
                }else {
                    this.exhibitsCancelStore(_item)
                }
            }
        },
        handleLangExhibitsStore(_item) {
            if(_item.is_store) {
                if(this.language == 'zh') {
                    return '已收藏'
                }else {
                    return 'Stored'
                }
            }else {
                if(this.language == 'zh') {
                    return '收藏'
                }else {
                    return 'Store'
                }
            }
        },
        exhibitsStore(_item) {
            api.isCollectProduct({
                exhibition_product_id: _item.id
            }).then((res) => {
                if (res.res == 1) {
                    this.$message.success("收藏成功");
                    _item.is_store = 1;
                }
            });
        },
        exhibitsCancelStore(_item) {
            api.noCollectProduct({
                exhibition_product_id: _item.id
            }).then((res) => {
                if (res.res == 1) {
                    this.$message.success("取消收藏");
                    _item.is_store = 0;
                }
            });
        },
        goExhibitorDetail(_id,_exhibition_id,_vhall_id){
            this.$router.push({
               path: '/area/ztDetail',
               query:{
                 company_id: _id,
                 exhibition_id: _exhibition_id,
                 instance_id: _vhall_id
               }
            })
        },
        handleSearch(){
            if(this.valuePavilion == '100'){
                this.handleGetExhibitor()
                this.selectedOptions = []
            }else{
                this.handleGetExhibitionProduct()
            }
        },
        handleSearchPlace(){
            this.drawerExhibitor = true,
            this.getSearchPlace()
        },
        getSearchPlace(){
            api.getExhibitor({
                search: this.searchExhibitor,
                province: this.province,
                city: this.city,
                area: this.area,
                page: this.pageparam.currentPage,
                size: this.pageparam.size || 10,
                exhibition_id: all_exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    this.hasData = res.count;
                    // this.isEmpty = res.count == 0 ? true : false;
                    this.exhibitorData = res.list
                    this.pageparam.totalNum = res.count;
                    if(res.count == 0){
                        this.totalPage = 0
                        return
                    }
                    this.totalPage = Math.ceil(res.count / (this.pageparam.size || 10));
                }else{
                    this.$message.error(res.mes);
                }
            })
        },
        handleGetExhibitionProduct(){
            api.getExhibitionProduct({
                search: this.searchGoods,
                language: this.language == 'zh' ? 'cn' : 'en',
                page: this.pageparam.currentPage,
                size: 10,
                exhibition_id: all_exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    this.drawerGoods = true
                    this.goodsData = res.list
                    this.hasData = res.count;
                    this.pageparam.totalNum = res.count;
                    this.totalPage = Math.ceil(res.count /10);
                }else{
                    this.$message.error(res.mes);
                }
            })
        },
        handleGetExhibitor(){
            api.getExhibitor({
                search: this.searchExhibitor,
                page: this.pageparam.currentPage,
                size:  this.pageparam.size || 10,
                exhibition_id: all_exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    this.drawerExhibitor = true
                    this.exhibitorData = res.list
                    this.hasData = res.count;
                    this.pageparam.totalNum = res.count;
                    this.totalPage = Math.ceil(res.count / (this.pageparam.size || 10));
                }else{
                    this.$message.error(res.mes);
                }
            })
        },
        handleReview(){
            this.$message.success(this.$t("header").review_tip)
        },
        //获取登录ticket
        getTicket() {
          this.$http({
            method: 'get',
            url: `${process.env.API_HOST}/account/api/v1/sso-ticket`,
            params: {}
          }).then((response) => {
            if (response.res == 1) {
              window.location.href = `https://www.zhoushanexpo.com/?ticket=${response.sso_ticket}`
            } else {
              this.$message.error(response.mes);
            }
          }).catch((res) => {
          })
        },
        handleCommandOptionsPavilion(exhibitionId){
            if(exhibitionId == '33'){
                // 跳转舟展会(已登录的情况换取ticket再跳转)
                const token = localStorage.getItem("access_token");
                if(token) {
                    this.getTicket();
                }else {
                    window.location.href = `https://www.zhoushanexpo.com/`;
                }
                // this.$router.push({
                //   path: '/exhibitionView',
                //   query: {
                //     exhibitionId
                //   }
                // })
            }else if (exhibitionId == '35'){
                this.$router.push('/islandAgricultural')
            } else if (exhibitionId == '38'){
                this.$router.push('/hzFumao')
            } else if (exhibitionId == '53'){
                this.$router.push('/chukou2021')
            } else if (exhibitionId == '57'){
                this.$router.push('/chukou2022')
            }else if(exhibitionId == '58'){
                this.$router.push('/chukouXl2022')
            }else if(exhibitionId == '63') {
                this.$router.push('/sppl')
            }else if(exhibitionId == '78') {
                this.$router.push('/beltRoad')
            }else {
                this.$router.push({
                    path: '/area/zhanqu',
                    query:{
                        exhibition_id: exhibitionId,
                        status: '1',
                    }
                })
            }
        },
        handleCommandOptionsExhibition(command){
            if(command == '41' || command == '34' || command == '49' || command == '51' || command == '80' || command == '81'){
                this.$router.push({
                    path: '/area/zhanqu',
                    query:{
                        exhibition_id: command,
                        status: '0',
                    }
                })
            } else if (command === 55) {
              // 乌兹别克展
              this.$router.push('/uzi')
            } else {
                this.$router.push({
                    path: '/area/consult', 
                    query:{
                        exhibition_id: command,
                        status: '0',
                    }
                })
            }
        },
        handleCommandOptionsExhibitionEnd(command){
            if(command == '34' || command == '41' || command == '55' || command == '51' || command == '49' || command == '59' || command == '65' || command == '80' || command == '81'){
                this.$router.push({
                    path: '/area/zhanqu',
                    query:{
                        exhibition_id: command,
                        status: '0', 
                    }
                })
            }else{
                this.$router.push({
                    path: '/area/consult', 
                    query:{
                        exhibition_id: command,
                        status: '0',
                    }
                })
            }
        },
        toggleLanguage() {
            // if (this.language === this.languageValue) return;
            // this.language = this.languageValue;
            let type = this.languageValue
            changeLanuage(this.languageValue);
            if(this.$parent.$children[1].$refs.iframe){
                this.$parent.$children[1].$refs.iframe.contentWindow.postMessage(type , '*')
            }
        },
        // toggleLanguage(type) {
        //     // if (this.language === type) return;
        //     // this.language = type;
        //     // let message = this.language
        //     // console.log(window)
        //     // this.$parent.$children[1].refs.iframe.contentWindow;
        //     if(this.$parent.$children[1].$refs.iframe){
        //         this.$parent.$children[1].$refs.iframe.contentWindow.postMessage(type , '*')
        //     }
        //     changeLanuage(type);
        //     // console.log(this.$parent.$children[1].$refs.iframe.contentWindow)
        // },
        goPage(path) {
            this.$router.push(path);
            if(window.location.href.indexOf('https://www.zhoushanexpo.com/') > -1) {
                document.title = '舟展汇';
            }
        },
        handleChoose(){
            
        },
        handleChange (value) {
            if(value[0] != ''){
                this.province = value[0]
                if(value[1] != ''){
                    this.city = value[1]
                    if(value[2] != ''){
                        this.area = value[2]
                    }else{
                        this.area = ''
                        return
                    }
                }else{
                    this.city = ''
                    this.area = ''
                    return
                }
            }else{
                this.province = ''
                this.city = ''
                this.area = ''
                return
            }
            // this.province = value[0]
            // console.log(this.province, '221')
            // this.city = value[1]
            // this.area = value[2]
        },
        getOptionsPavilion(){
            api.getExhibition({
                lasting: '1',
                company_id: '582'
            }).then((res)=>{
                if(res.res == 1){
                    res.list.forEach((item,index) => {
                        if(item.id == 33 || item.id == 38 || item.id == 57 || item.id == 58 || item.id == 63 || item.id == 78){
                            this.newoption.push(item)
                            this.optionsPavilion = this.newoption
                        }
                    });
                }
            })
        },
        getOptionsExhibition(){
            api.getExhibition({
                lasting: '0',
                status: '2',
                company_id: '582'
            }).then((res)=>{
                if(res.res == 1){
                    res.list.forEach((item, index) => {
                        if(item.id != 76 && item.id != 77 && item.id != 79){
                            this.optionsExhibition.push(item)
                        }
                    })
                }
            })
        },
        getOptionsExhibitionEnd(){
            api.getExhibition({
                lasting: '0',
                status: '3',
                company_id: '582'
            }).then((res)=>{
                if(res.res == 1){
                    res.list.forEach((item,index) => {
                        // this.optionsExhibitionEnd = res.list
                        if(item.id != 15 && item.id != 14 && item.id != 62){
                            this.newoptionEnd.push(item)
                            this.optionsExhibitionEnd = this.newoptionEnd
                        }
                    });
                }
            })
        },
        callFather(param) {
            this.pageparam.currentPage = param.currentPage;
            // 获取列表
            if(this.valuePavilion == '101'){
                this.handleGetExhibitionProduct()
            }else{
                this.handleGetExhibitor()
            }
        },
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";
/deep/ .el-input{
    height: 100%;
}
/deep/ .el-input__inner {
    height: 100%!important;
}
/deep/ .el-select .el-input .el-select__caret{
    font-size: 20px;
    color: #778DB3;
}
/deep/ .el-popper .popper__arrow::after {
  content: none;
}
/deep/ .el-popper .popper__arrow {
  border: 0;
}
// /deep/ .el-select .el-input--suffix{
//     width: 70px;
// }
/deep/ .el-input__inner{
    background: unset;
    border: unset;
    height: 20px;
    font-size: 18px;
    color: #49546B
}
/deep/ .el-input__icon{
    line-height: 20px;
    font-size: 20px;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #194B96;
}
.el-dropdown-link {
    font-size: 18px;
    cursor: pointer;
    color: #49546B;
    .active{
        color:#194B96
    }
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
@media screen and (max-width:1440px){
    .header-wrapper{
        height: 60px;
        .container-headder{
            .search-input{
                height: 33px;
            }
            .cotentBox-logo {
                height: 33px;
                > img {
                    max-height: 33px;
                }
            }
        }
    }
}
@media screen and (min-width:1440px) and (max-width:1600px){
    .header-wrapper{
        height: 80px;
        .container-headder{
            .search-input{
                height: 36px;
            }
            .cotentBox-logo {
                height: 36px;
                > img {
                    max-height: 36px;
                }
            }
        }
    }
}
@media screen and (min-width:1600px){
    .header-wrapper{
        height: 100px;
        .container-headder{
            .search-input{
                height: 44px;
            }
            .cotentBox-logo {
                height: 44px;
                > img {
                    max-height: 44px;
                }
            }
        }
    }
}
.page{
    position: absolute;
    bottom: 20px;
    right: 0px;
    left: 0px;
}
.header-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 999;
    // height: 100px;
    min-width: 1400px;
    width: 100%;
    background: rgba(255, 255, 255, 0.65);
    .container-headder {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        width: 100%;
        height: 100%;
        // padding-left: 21px;
        .search-input{
            display: flex;
            // width: 312px;
            // height: 44px;
            border-radius: 22px;
            border: 2px solid #8390A8;
            padding: 6px;
            margin-left: 30px;
            align-items: center;
            // width: 382px;
            .icon {
                // margin-right: 10px;
                width: 24px;
                height: 24px;
                cursor: pointer;
                // margin-top: 2px;
            }
        }
        .cotentBox-logo {
            max-width: 380px;
            margin-left: 120px;
            // height: 44px;
            > img {
                max-width: 100%;
                // max-height: 44px;
                object-fit: contain;
            }
        }
        .main{
            display: flex;
            justify-content: space-around;
            align-items: center;
            // flex: 2;
            .header-titile-name{
                font-size: 18px;
                font-weight: 400;
                color: #49546B;
            }
            .cotentBox-home{
                display: flex;
                // margin-right: 3%;
                font-size: 18px;
                cursor: pointer;
                margin-left: 8%;
                display: flex;
                justify-content: center;
                align-items: center;
                .header-titile-name{
                    color: #194B96;
                }
                // width: 100px;
                // &.active{
                //     color: #194B96;
                // }
                &:hover{
                    .header-titile-name{
                        color: #194b96;
                    }
                }
                &:active{
                    // .header-titile-name{
                    //     color: #194b96;
                    // }
                    color: #194b96;
                    

                }
            }
            .cotentBox-pavilion{
                display: flex;
                justify-content: center;
                align-items: center;
                // width: 118px;
                // margin-right: 3%;
                &:hover{
                    .header-titile-name{
                        color: #194b96;
                    }
                }
                &:active{
                    // .header-titile-name{
                    //     color: #194b96;
                    // }
                    color: #194b96;
                }
            }
            .cotentBox-language {
                display: flex;
                justify-content: center;
                align-items: center;
                // width: 220px;
                // margin-right: 1%;
                // height: 45px;
                // background: #ffffff;
                // box-shadow: 0px 5px 11px 0px rgba(108, 156, 188, 0.14);
                border-radius: 16px;
                font-size: 18px;
                cursor: pointer;
                // margin-right: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #49546B;
                .icon {
                    width: 20px;
                    height: 20px;
                    margin-right: 16px;
                    border-radius: 50%;
                    display: block;
                }
                >img{
                    width: 21px;
                    height: 21px;
                }
                /deep/ .el-input--suffix{
                    width: 70px;
                }
                /deep/ .el-input__suffix{
                    right: 13px;
                    top: 1px;
                }
                /deep/ .el-input__inner{
                    padding-right: unset;
                    padding-left: 8px;
                }
                /deep/ .el-select .el-input .el-select__caret{
                    font-size: 12px;
                }
                .line {
                    margin: 0 auto;
                }
                .active {
                    color: rgba(2, 68, 142, 0.24);
                }
            }
            .cotentBox-userInfo {
                // position: absolute;
                // top: 32.5px;
                // right: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
                // text-align: left;
            }
        }
    }
    /deep/ .el-drawer__header{
        display: none;
        
    }
    /deep/ .el-tabs__header{
        margin: 30px 390px 20px 250px
    }
    /deep/ .el-tabs__content{
        margin: 30px 250px 20px 250px
    }
    /deep/ .el-drawer{
        height: 90% !important;
        box-shadow: 0px -10px 30px 0px rgba(6, 58, 120, 0.5);
    }
    /deep/ .el-tabs__item{
        font-size: 18px;
    }
    /deep/ .el-tabs__nav-wrap::after{
        width: unset;
    }
    .exhibitorDrawer{
        overflow-y: scroll;
        max-height: calc(100vh - 240px);
        /*定义滚动条高宽及背景*/
        &::-webkit-scrollbar {
            width: 1px;
        }
        /*定义滚动条*/
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px #fff;
            background: #fff;
        }
        /*定义滚动条轨道*/
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px #fff;
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
        }
        margin: 30px 240px 0px 240px;
        .exhibitorDrawer-search-name{
            height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: #49546B;
            line-height: 22px;
        }
        .exhibitorDrawer-search-place{
            display: flex;
            align-items: center;
            margin: 30px 0 25px 0;
            .pick-place{
                // width: 80px;
                height: 22px;
                font-size: 16px;
                font-weight: 400;
                color: #49546B;
                line-height: 22px;
            }
            .pick-button{
                width: 382px;
                height: 44px;
                background: #FFFFFF;
                border-radius: 22px;
                border: 1px solid #194B96;
                display: flex;
                align-items: center;
            }
        }
        .el-row{
            // max-height: calc(100vh - 250px);
            // overflow-y: scroll;
            
            .exhibitor-item-wrap{
                cursor: pointer;
                width: 19%;
                height: 210px;
                background: #F2F7FF;
                border-radius: 10px;
                border: 1px solid #C9C9D8;
                box-sizing: border-box;
                margin: 0px 10px 20px 0px;
                .exhibitor-item{
                    .exhibitor-img-content{
                        width: 100%;
                        height: 130px;
                        background-size: 100%;
                        background-color: #fff;
                        border-radius: 10px 10px 0 0;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        // padding: 8px 0px;
                        // margin: 10px 0px;
                        .new-store{
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 28px;
                            height: 28px;
                        }
                        .exhibitor-img{
                            max-width: 100%;
                            max-height: 130px;
                            object-fit: contain;
                            // border-radius: 10px 10px 0 0;
                            // padding: 10px;
                        }
                        .company-view-item{
                            position: absolute;
                            top: 5px;
                            left: 1px;
                            // background: red;
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                            // display: flex;
                            // align-items: center;
                            font-size: 14px;
                            
                            .icon-store{
                                font-size: 19px;
                                box-shadow: 2px #194B96;
                                &:hover{
                                    color: #194B96;
                                }
                            }
                            .unactive{
                                color: #8d8d8d;
                            }
                            .active{
                                color: #194B96;
                            }
                        }
                    }
                    // .exhibitor-img{
                    //     width: 100%;
                    //     height: 130px;
                    //     object-fit: contain;
                    //     border-radius: 10px 10px 0 0;
                    // }
                    .exhibitor-content{
                        height: 80px;
                        margin-left: 16px;
                        margin-right: 10px;
                        .exhibitor-content-name{
                            font-size: 16px;
                            font-weight: 500;
                            color: #333333;
                            height: 22px;
                            line-height: 22px;
                            margin: 8px 0 3px 0;
                            // width: 230px;
                            overflow:hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .exhibitor-content-place{
                            height: 17px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #666666;
                            line-height: 17px;
                            margin-bottom: 3px;
                            // width: 230px;
                            overflow:hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .exhibitor-content-exhname{
                            height: 17px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #666666;
                            line-height: 17px;
                            // width: 210px;
                            overflow: hidden;
                            text-overflow:ellipsis; 
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
        .no_data{
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin-top: 15%;
            align-items: center;
            img{
                width: 100px;
                height: 100px;
                display: flex;
                justify-content: center;
                margin-bottom: 20px;
            }
        }
    }
    .goodsDrawer{
        overflow-y: scroll;
        max-height: calc(100vh - 200px);
        /*定义滚动条高宽及背景*/
        &::-webkit-scrollbar {
            width: .5px;
        }
        /*定义滚动条*/
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px #fff;
            background: #fff;
        }
        /*定义滚动条轨道*/
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px #fff;
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
        }
        margin: 30px 240px 0px 240px;
        .no_data{
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin-top: 15%;
            align-items: center;
            img{
                width: 100px;
                height: 100px;
                display: flex;
                justify-content: center;
                margin-bottom: 20px;
            }
        }
        .goodsDrawer-search-name{
            height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: #49546B;
            line-height: 22px;
            margin-bottom: 30px;
        }
        .goodsDrawer-search-place{
            display: flex;
            align-items: center;
            margin: 30px 0 25px 0;
            .pick-place{
                // width: 80px;
                height: 22px;
                font-size: 16px;
                font-weight: 400;
                color: #49546B;
                line-height: 22px;
            }
            .pick-button{
                width: 382px;
                height: 44px;
                background: #FFFFFF;
                border-radius: 22px;
                border: 1px solid #194B96;
                display: flex;
                align-items: center;
            }
        }
        .goods-item-wrap{
            cursor: pointer;
            // padding: 20px 6px;
            width: 19%;
            height: 300px;
            background: #FFFFFF;
            border-radius: 10px;
            border: 1px solid #C9C9D8;
            box-sizing: border-box;
            margin: 0px 10px 20px 0px;
            .goods-item{
                .goods-img-content{
                    width: 100%;
                    height: 210px;
                    background-size: 100%;
                    background-color: #fff;
                    border-radius: 10px 10px 0 0;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .new-store{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 28px;
                        height: 28px;
                    }
                    .goods-img{
                        width: 100%;
                        height: 100%;
                        // padding: 10px;
                        // object-fit: scale-down;
                        border-radius: 10px 10px 0 0;
                    }
                    .company-view-item{
                        position: absolute;
                        top: 5px;
                        left: 5px;
                        // background: red;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                        // display: flex;
                        // align-items: center;
                        font-size: 14px;
                         .icon-store{
                            font-size: 19px;
                            box-shadow: 2px #194B96;
                            &:hover{
                                color: #194B96;
                             }
                        }
                        .unactive{
                            color: #8d8d8d;
                        }
                        .active{
                            color: #194B96;
                        }
                    }
                }
                .goods-content{
                    // height: 40px;
                    margin: 0px 0px 8px 12px;
                    .goods-content-name{
                        font-size: 16px;
                        font-weight: 500;
                        color: #333333;
                        height: 22px;
                        line-height: 22px;
                        margin: 8px 0 3px 0;
                        // width: 230px;
                        overflow:hidden;
				        white-space: nowrap;
				        text-overflow: ellipsis;
                    }
                    .goods-content-place{
                        height: 17px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        margin-bottom: 3px ;
                        overflow:hidden;
				        white-space: nowrap;
				        text-overflow: ellipsis;
                    }
                    .goods-content-exhname{
                        height: 17px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        // width: 230px;
                        overflow:hidden;
				        white-space: nowrap;
				        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/components/Headers.vue